import * as api from "./api";
import { StatisticsResponse } from "../store/config";

const getAuthToken = () => {
  return localStorage.getItem("token") || "{}";
};

export const fetchStatistics = async () => {
  const token = getAuthToken();
  api.setHeaderAuthorization(token);
  const response: any = await api.get("/statistics");
  return response;
};

export const updateStatistics = async (
  id: string,
  updatedData: Partial<StatisticsResponse["data"]>
) => {
  try {
    const token = getAuthToken();
    api.setHeaderAuthorization(token);
    const response = await api.put(`/statistics/${id}`, updatedData);
    return response;
  } catch (error) {
    throw error;
  }
};
